import { CalendarId } from 'mini-event-to-calendar-association/lib/schema/CalendarId';

/**
 * Replacing the folderIdMapper key with the new one
 * @param folderIdMapping Map in which the key is to be replaced
 * @param oldFolderId Key to be replaced
 * @param newFolderId Key to be replaced with the old one
 */
export const globalUpdateFolderIdMapping = (
    folderIdMapping: Map<string, CalendarId>,
    oldFolderId: string,
    newFolderId: string
) => {
    if (oldFolderId !== newFolderId && folderIdMapping.has(oldFolderId)) {
        folderIdMapping.set(newFolderId, folderIdMapping.get(oldFolderId));
        folderIdMapping.delete(oldFolderId);
    }
};
